<template>
  <div class="flex-column d-block" v-bind:style="darkBackgroundStyle" :class="platform.name != 'IE' ? 'd-flex':''">
    <a v-if="this.$route.path=='/recommend'" href="javascript:void(0)" @click="sendAnalytics($event)" :data-worktitle="workName">
        <progressive-img :src="imageUrl" class="img-fluid" style="vertical-align: bottom"/>
    </a>
    <a v-else href="javascript:void(0)" @click="sendAnalytics($event)" :data-worktitle="workName">
        <progressive-img :src="imageUrl" class="img-fluid" style="vertical-align: bottom"/>
    </a>
    <p class="d-none d-md-block mt-1 text-center text-truncate" v-bind:style="textStyle" >{{ workName }}</p>
    <p class="d-none d-md-block mt-1 text-center">
      <a v-if="this.$route.path=='/recommend'" v-show="shouldShowReadButton" class="btn btn-read-recommend-panel mb-2"
         v-bind:style="buttonStyle"
         href="javascript:void(0)" @click="sendAnalytics($event)"
         :data-worktitle="workName">試し読み</a>
      <a v-else v-show="shouldShowReadButton" class="btn btn-read-recommend-panel mb-2"
         v-bind:style="buttonStyle"
         href="javascript:void(0)" @click="sendAnalytics($event)" :data-worktitle="workName">試し読み</a>
    </p>
  </div>
</template>

<script>
import * as consts from '../constants';
import dynamicStyleMixin from "../components/DynamicStyleMixin";

  export default {
    name: "RecommendReadThumbnail",
    props: {
      /** @type {KoreyomoWorkItem} */
      workItem: {
        type: Object,
        default: () => null
      },
      textStyle: {
        type: Object,
        default: () => null
      },
      darkBackgroundStyle: {
        type: Object,
        default: () => null
      },
      buttonStyle: {
        type: Object,
        default: () => null
      },
      personaId: {
        type: [String, Number],
        default: () => undefined
      },
      timeRes: {
        type: String,
        default: () => null
      },
      restoreToken: {
        type: String,
        default: () => null
      },
      readPages: {
        type: Number,
        default: () => 1
      },
      totalPages: {
        type: Number,
        default: () => 1
      },
    },
    computed: {
      platform: () => platform,
      imageUrl: function() {
        return this.workItem ? this.workItem.bannerMediumImageUrl : null
      },
      workCode: function() {
        return this.workItem ? this.workItem.workCode : null
      },
      workName: function() {
        return this.workItem ? this.workItem.workName : null
      },
      shouldShowReadButton: function () {
        return this.workItem != null
      }
    },

    methods: {
      sendAnalytics: function(e){
          let workTile = e.target.dataset.worktitle
          this.gtagFunction(consts.HIT_TYPE.CLICK, consts.EVENT_CATEGORY.KOREYOMO,consts.EVENT_LABEL.RECOMMEND_PRE+'_'+workTile+consts.EVENT_LABEL.RECOMMEND_POST,this.getMangahotDetailUrl(this.workCode, this.restoreToken, this.personaId, this.timeRes));
      }
    },
    created() {
      
    }
    
  
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/RecommendReadThumbnail.vue